(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name flightPunctuality.factory:FlightPunctualityRequestFactory
     *
     * @description
     *
     */
    angular
    	.module('flightPunctuality')
        .factory('FlightPunctualityRequestFactory', FlightPunctualityRequestFactory);

    function FlightPunctualityRequestFactory() {

        function SearchCriteriaDTO(){
            this.fromDate = null;
            this.toDate = null;
            this.fromTime = null;
            this.toTime = null;
            this.fromAirport = null;
            this.toAirport = null;
            this.pageSize = null;
            this.startPosition = null;
            this.status = null;
            this.acModel = null;
            this.flightNo = null;
        }

        /*function FlightDTO(){
        	this.flightLegId = null;
			this.flightNumber = null;
			this.actualDepartureTime = null;
			this.route = null;
			this.aircraftRegistrationNumber = null;
			this.status = null;
			this.gateNumber = null;
			this.takeOffTime = null;
			this.departureDelay = null;
			this.departureDelayCode = null;
			this.landingTime = null;
			this.actualArrivalTime = null;
			this.arrivalDelay = null;
			this.arrivalDelayCode = null;
			this.totalPaxCount = null;
			this.crew = null;
        }*/


        function GetSearchRequest(searchParam) {
            var searchRequest = new SearchCriteriaDTO();
			searchRequest.fromDate = searchParam.fromDate;
			searchRequest.toDate = searchParam.toDate;
			searchRequest.fromAirport = searchParam.origin == null || searchParam.origin == " " ? null : searchParam.origin.airPortCode;
			searchRequest.toAirport = searchParam.destination == null || searchParam.destination == " " ? null : searchParam.destination.airPortCode;
			searchRequest.pageSize = searchParam.pageSize;
			searchRequest.startPosition = searchParam.startPosition;
			searchRequest.flightNo =  searchParam.flightNo == null || searchParam.flightNo == " " ? null : searchParam.flightNo;
			searchRequest.status =  searchParam.status == null || searchParam.status == " " ? null :searchParam.status.flightStatusCode;
			searchRequest.acModel =  searchParam.fleet == null || searchParam.fleet == " " ? null :searchParam.fleet.airCraftType;
			searchRequest.fromTime = !!searchParam.fromTime ? searchParam.fromTime:null;
			searchRequest.toTime = !!searchParam.toTime ? searchParam.toTime:null;
			return searchRequest;
        }

        function GetFormattedFlights(flightLegs) {
        	if(flightLegs == null){
        		flightLegs = [];
        	}
        	
			angular.forEach(flightLegs, function(flight) {
				flight.delaysDepartureStrings = flight.delaysDepartureStrings.length == 0 ? "" : flight.delaysDepartureStrings.toString().split(/,/i).join(', ');
				flight.delaysArrivalStrings = flight.delaysArrivalStrings == 0 ? "" : flight.delaysArrivalStrings.toString().split(/,/i).join(', ');
			});
			return flightLegs;
        }

        return {
        	getSearchRequest: GetSearchRequest,
        	getFormattedFlights: GetFormattedFlights
        }
    }
})();
